export var BusinessKYCProcessor;
(function (BusinessKYCProcessor) {
    BusinessKYCProcessor["Sumsub"] = "SUMSUB";
    BusinessKYCProcessor["Afriex"] = "AFRIEX";
    BusinessKYCProcessor["Aiprise"] = "AIPRISE";
})(BusinessKYCProcessor || (BusinessKYCProcessor = {}));
//# sourceMappingURL=BusinessKYCProcessor.js.map